<app-top-bar-wrapper [type]="DashboardType.SOCIAL_OVERVIEW">
    <div dashboard class="social-overview-screen">
      <div class="main-container">
        <section class="section section--hero" [style.background-image]="'url(' + ('/images/social-overview-header-background.png' | assetVersion) + ')'">
          <div class="hero-banner">
            <div class="hero-content">
              <h1 class="hero-title">Social</h1>
              <p class="hero-subtitle">Analyze social reach, spend, and creative mix</p>
            </div>
          </div>
        </section>
        <section class="section">
          <app-overview-tiles
            [type]="'social-overview'"
            [overview]="overview"
            [loading]="loadingOverviewDashboard"
            [brandColors]="brandColorsMap()"
            [myBrand]="dashboardService.brandsFilters().myBrand.key"
            [showAskPolaris]="true">
        </app-overview-tiles>

        </section>
        <section class="section">
          <div class="widgets-wrapper">
            <div class="widget-container gallery">
              <app-widget-container
                [title]="'Creative Gallery'"
                [tooltip]="tooltips.creativeGallery"
                [control]="gallerySortControl"
                [selectMode]="SelectMode.SINGLE"
                [selectOptions]="gallerySortOptions"
                [searchable]="false"
                [selectWidth]="'250px'"
                [askPolarisWidget]="WIDGET_QUESTIONS_MAPPING_FOR_DOMAIN.SOCIAL_CREATIVE_GALLERY"
                (apply)="onGallerySortChange()">
                <app-creative-gallery
                  [cardType]="'social'"
                  [socialData]="creativeGalleryData"
                  [brandIconMap]="brandIconMap"
                  [loading]="loadingCreativeGallery"
                  [sortBy]="gallerySortControl.value">
                </app-creative-gallery>
              </app-widget-container>
              <div class="paginator-container">
                <app-paginator
                  [length]="totalSocialCards"
                  [pageSize]="GALLERY_PAGE_SIZE"
                  [initialPage]="1"
                  [currentPage]="currentGalleryPage + 1"
                  (page)="onGalleryPageChange($event)">
                </app-paginator>
              </div>
            </div>
          </div>
        </section>
        <section class="section section--sov-performance">
          <div class="widgets-wrapper">
            <div class="widget-container share-of-voice">
              <app-widget-container
                [title]="SHARE_OF_VOICE_WIDGET_TITLE"
                [tooltip]="tooltips.shareOfVoice"
                [minHeight]="464"
                [askPolarisWidget]="WIDGET_QUESTIONS_MAPPING_FOR_DOMAIN.SOCIAL_SHARE_OF_VOICE">
                <app-pie-chart
                  [loading]="loadingOverviewDashboard"
                  [data]="sovData"
                  [colors]="sovColors"
                  [isCompactMode]="true"
                  [chartWidth]="388"
                  format="percentage"
                  valueField="share">
                </app-pie-chart>
              </app-widget-container>
            </div>
          </div>
          <div class="widgets-wrapper">
            <div class="widget-container performance-over-time">
              <app-widget-container
                [title]="'Performance Over Time'"
                [tooltip]="tooltips.performanceOverTime"
                [control]="performanceMetricControl"
                [selectMode]="SelectMode.SINGLE"
                [selectOptions]="performanceMetricOptions"
                [searchable]="false"
                [selectWidth]="'248px'"
                [disabledByLength]="true"
                [minHeight]="464"
                [askPolarisWidget]="WIDGET_QUESTIONS_MAPPING_FOR_DOMAIN.SOCIAL_PERFORMANCE_OVER_TIME"
                (apply)="onPerformanceMetricChange()">
                <app-performance-over-time
                  [data]="performanceData"
                  [loading]="loadingPerformanceOverTime"
                  [metric]="performanceMetricControl.value"
                  [brandColors]="brandColorsMap()"
                  [brandLineColorsMap]="brandLineColorsMap()"
                  valueField="share"
                  [format]="performanceOverTimeFormat"
                  [isUnderDateThreshold]="performanceDataIsUnderDateThreshold">
                </app-performance-over-time>
              </app-widget-container>
            </div>
          </div>
        </section>
        <section class="section">
          <div class="widgets-wrapper">
            <div class="widget-container channel-distribution">
              <app-widget-container
                [title]="'Channel Distribution by Spend'"
                [tooltip]="tooltips.channelDistribution"
                [minHeight]="464"
                [askPolarisWidget]="WIDGET_QUESTIONS_MAPPING_FOR_DOMAIN.SOCIAL_CHANNEL_DISTRIBUTION">
                <app-channel-distribution
                  [data]="channelDistribution"
                  [loading]="loadingOverviewDashboard">
                </app-channel-distribution>
              </app-widget-container>
            </div>
          </div>
        </section>
        <section class="section">
          <div class="widgets-wrapper">
            <div class="widget-container ad-type">
              <app-widget-container
                [title]="'Ad Type by Spend'"
                [tooltip]="tooltips.adType"
                [askPolarisWidget]="WIDGET_QUESTIONS_MAPPING_FOR_DOMAIN.SOCIAL_AD_TYPE">
                <app-ad-type-distribution
                  [data]="adType"
                  [myBrand]="dashboardService.brandsFilters().myBrand"
                  [myCompetitors]="dashboardService.brandsFilters().myCompetitors"
                  [brandColorsMap]="brandColorsMap()"
                  [loading]="loadingOverviewDashboard">
                </app-ad-type-distribution>
              </app-widget-container>
            </div>
          </div>
        </section>

      </div>
    </div>
</app-top-bar-wrapper>
